export default __webpack_public_path__ + "content/media/linkvive.c7885433.png";